import React from 'react';
import { Calendar, MapPin, Users } from 'lucide-react';
import { formatEventTimeRange } from '../../utils/dateFormat';

/**
 * EventDetailsStrip — description + date/location/capacity row for the event page.
 * Pure presentational. Reads event + availability only.
 */
export default function EventDetailsStrip({ event, availability }) {
  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-[#EAE7E1] tracking-tight mb-4">About This Event</h2>
        <p className="text-base text-[#AFAFAF] leading-relaxed">{event.description}</p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center text-[#EAE7E1]">
          <Calendar className="w-5 h-5 mr-3 text-[#D4AF37]" />
          <span className="font-medium">{formatEventTimeRange(event)}</span>
        </div>
        <div className="flex items-center text-[#EAE7E1]">
          <MapPin className="w-5 h-5 mr-3 text-[#D4AF37]" />
          <span className="font-medium">
            {event.location || (event.location_visibility === 'revealed_later' ? 'Location will be shared before the event' : event.location_visibility === 'hidden' ? 'Location is private' : 'TBA')}
          </span>
        </div>
        {availability && (
          <div className="flex items-center text-[#EAE7E1]">
            <Users className="w-5 h-5 mr-3 text-[#D4AF37]" />
            <span className="font-medium">
              {availability.is_unlimited_capacity || event.is_unlimited_capacity
                ? 'Unlimited spots'
                : `${Math.max(0, Number(availability.remaining_capacity ?? 0))} spots remaining`}
            </span>
          </div>
        )}
      </div>
    </>
  );
}
